import React, { Component } from 'react'
import t from '../components/Language/language'
import * as languageSettings from '../components/Language/languageSettings'
import StoredetailsComponent from '../components/Stores/StoreDetailsComponent'
import ZoomComponent from '../components/Stores/ZoomComponent'
import CIBComponent from '../components/Stores/CIBComponent'
import Device from '../components/Stores/Device'
import 'url-search-params-polyfill'
import * as ReactBootstrap from 'react-bootstrap'
import { connect } from 'react-redux'
import { closePopup } from '../actions/modalAction'
import AuthenticationService from '../../src/components/Security/AuthenticationService'
import { Config } from '../Config'
// ModalContainer- Component
class ModalContainer extends Component {
  constructor (props, context) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    let initTab = 'Store Details'
    this.state = {
      show: false,
      key: 1,
      activetab: initTab,
      tabData: [],
      currentLanguage: languageSettings.getCurrentLanguage()
    }
    this.renderTabComponent = this.renderTabComponent.bind(this)
    this.storeTabs = this.storeTabs.bind(this)
    this.viewDevice = this.viewDevice.bind(this)
    this.authService = new AuthenticationService(Config.authBaseUrl)
  }

  // get the device UID and redirect to viewdetails page
  viewDevice (did) {
    this.props.dispatch(closePopup())
    const params = new URLSearchParams(this.props.history.location.search)
    const uuid = params.get('uuid') ? params.get('uuid') : null
    if (uuid) {
      window.location.href = '/settings/stores/viewDetail?duid=' + did + '&uuid=' + uuid
    } else {
      window.location.href = '/settings/stores/viewDetail?duid=' + did
    }
  }

  // Select the device
  handleSelect (key) {
    this.setState({ key })
  }

  // Popup close function
  handleClose () {
    this.setState({ state: null })
    this.props.dispatch(closePopup())
  }

  // Displaying Store details
  storeTabs (array) {
    const language = this.state.currentLanguage
    let Tab = ReactBootstrap.Tab
    return array.map((tabItem, index) => {
      if (tabItem && tabItem.Device_Name) {
        return (
          <Tab eventKey={index + 1} title={tabItem.Device_Name !== undefined ? (tabItem.Device_Name === 'Store Details' ? t[language].storeListStoreDetails : tabItem.Device_Name) : ''} onClick={this.handleClick}>
            {tabItem.Device_Name !== undefined ? this.renderTabComponent(tabItem.Device_Name, this.props.stores.storePopUpDetailisAdmin, tabItem) : ''}
          </Tab>
        )
      } else {
        return (
          ''
        )
      }
    })
  }

  // Displaying  device component based on device
  renderTabComponent (tabcomponent, isAdmin, tabItem) {
    switch (tabcomponent) {
      case 'Store Details':
        return <StoredetailsComponent isAdmin={isAdmin} close={this.handleClose} history={this.props.history} />
      case 'CIB':
        return <CIBComponent isAdmin={isAdmin} viewDevice={this.viewDevice} isRemoteConnection={this.props.isRemoteConnection} />
      case 'EOS':
        return <Device isAdmin={isAdmin} viewDevice={this.viewDevice} isRemoteConnection={this.props.isRemoteConnection} device='EOS' />
      case 'ION':
        return <Device isAdmin={isAdmin} viewDevice={this.viewDevice} isRemoteConnection={this.props.isRemoteConnection} device='ION' />
      case 'ZOOM':
        return <ZoomComponent isAdmin={isAdmin} viewDevice={this.viewDevice} isRemoteConnection={this.props.isRemoteConnection} />
      default:
    }
  }
  // Main render function
  render () {
    let Modal = ReactBootstrap.Modal
    let Tabs = ReactBootstrap.Tabs
    let show = false
    if (this.props.stores.storePopUpClient !== undefined && this.props.stores.storePopUpClient) {
      show = this.props.stores.storePopUpClient
    } else if (this.props.stores.storePopUpAdmin !== undefined && this.props.stores.storePopUpAdmin) {
      show = this.props.stores.storePopUpAdmin
    }
    let array = []
    array.push({ Device_Name: 'Store Details', isActive: true })
    array = (this.props.stores.storePopupDetails !== undefined) ? array.concat(this.props.stores.storePopupDetails.Device_Details) : array
    if (array.Device_Details !== undefined) {
      array = array.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.Device_Name === thing.Device_Name || ''
        ))
      )
    }
    return (
      <Modal show={show} dialogClassName={'store-modal-popup ' + (this.authService.isAdmin() ? 'adminPopUp' : 'clientPopUp')} onHide={this.handleClose} >
        <Modal.Body className='store-modal-content'>
          <Tabs
            activeKey={this.state.key}
            onSelect={this.handleSelect}
            id='store-tabs' className={'custom-margin ' + (this.props.stores.storePopUpDetailisAdmin ? 'admin' : 'public')}
          >
            {this.storeTabs(array)}
          </Tabs>
          <div className='merger-popup-close' onClick={this.handleClose}>X</div>
        </Modal.Body>
      </Modal>

    )
  }
}
// get the state details from redux action.
function mapStateToProps (state) {
  return {
    stores: state.StorePopupDetails
  }
}

export default connect(mapStateToProps)(ModalContainer)



// WEBPACK FOOTER //
// ./src/containers/ModalContainer.js